import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'MalariaSpot-Web-Competition';
  constructor(translate: TranslateService) {
    translate.setDefaultLang('es');
  }
}
